import { collection_name, type } from "@/types/projectConsts";
import { flattenObj } from "@/utils/lodash";
const sorted = {
  date_created: -1,
};

// export const INITIAL_LOADING_NEWS_OPTIONS = {
//   limit: process.env.NEWS_LOADING_LIMIT,
//   condition: {
//     ngon_ngu: "vi",
//   },
// };

const processKeys = {
  all: [{ scope: "processes", limit: 100, sorted }],
  count: (options: any) => [
    {
      scope: "processes",
      type: "count",
      sorted,
      ...flattenObj(options || {}),
    },
  ],
  list: (options: any) => [
    {
      scope: "processes",
      type: "list",
      sorted,
      ...flattenObj(options || {}),
    },
  ],
  first: () => [
    {
      scope: "processes",
      type: "list",
      sorted,
      // ...flattenObj(INITIAL_LOADING_NEWS_OPTIONS),
    },
  ],
  detail: (slug: string, locale: string = "vi") => [
    { scope: "processes", type: "detail", slug, locale },
  ],
};

export default processKeys;
